import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  QueryList,
  ViewChild,
  ViewChildren
} from '@angular/core';
import {Offer} from '../../../../model/offer/offer';

import {OfferType} from '../../../../enum/offer-type';
import {combineLatest, map, merge, Observable, startWith, Subject, take, takeUntil} from 'rxjs';
import {OfferFormBase} from '../../create-offer-tab/create-offer-elements/offer-form-base/offer-form-base.component';
import {selectUserRoles} from '../../../../store/auth/selectors/auth.selectors';
import {selectUser} from '../../../../store/user/selectors/user.selectors';
import {Store} from '@ngrx/store';
import {UserAppState} from '../../../../store/user/reducers/user.reducer';
import {Roles} from '../../../../enum/roles';
import {Route} from '../../../../enum/route';
import {Router} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {ProposalUser} from '../../../../model/proposal/proposalUser';
import {OfferTransferService} from '../../../../services/offer/offer-transfer.service';
import {OfferFileUploadComponent} from '../../create-offer-tab/create-offer-elements/offer-file-upload/offer-file-upload.component';
import {FileUploadService} from '../../../../services/file-upload-service/file-upload.service';

@Component({
    selector: 'app-external-coverage',
    templateUrl: './external-coverage.component.html',
    styleUrls: ['./external-coverage.component.scss', '../../../../../styles/create-something.scss'],
    standalone: false
})
export class ExternalCoverageComponent implements AfterViewInit, OnDestroy {

  private readonly destroy$ = new Subject<void>();

  offer = new Offer();
  @Input() hasLead = false;
  @Input() maxCoverage = 100;
  allFormsValid$: Observable<boolean>;
  @Input() proposalId;
  @ViewChildren(OfferFormBase) formComponents: QueryList<OfferFormBase>;
  @ViewChild(OfferFileUploadComponent) offerFileUploadComponent: OfferFileUploadComponent;
  roles$ = this.userStore.select(selectUserRoles);

  user$ = this.userStore.select(selectUser);
  private roles: Roles[];

  @Output() uploadInProgress = new EventEmitter<boolean>();

  constructor(public dialog: MatDialog,
              private readonly changeDetector: ChangeDetectorRef,
              private readonly userStore: Store<UserAppState>,
              private readonly router: Router,
              private readonly offerTransferService: OfferTransferService,
              public fileUploadService: FileUploadService
  ) {
  }

  navigateToPreview(): void {
    const offer = new Offer();
    offer.offerType = OfferType.EXTERNAL_COVERAGE;
    offer.proposalId = this.proposalId;
    for (let form of this.formComponents) {
      form.updateOffer(offer);
    }

    this.user$.pipe(take(1)).subscribe(user => {
      offer.creator = new ProposalUser({ id: user.id });

      this.offerTransferService.offer = offer;

      this.router.navigate(['/' + Route.OFFER_PREVIEW]).then();
    });
  }

  ngOnInit() {
    this.roles$.pipe(takeUntil(this.destroy$)).subscribe(roles => this.roles = roles);
  }


  prefillForm(offer: Offer): void {
    this.formComponents.forEach(formComponent => {
      formComponent.prefill(offer);
    });
  }

  ngAfterViewInit(): void {

    //prefilling the form if there is an offer in the transfer service, and revalidating the form
    if(this.offerTransferService.offer){
      this.prefillForm(this.offerTransferService.offer);

      this.formComponents.forEach(formComponent => {
        formComponent.formGroup.markAllAsTouched();
        formComponent.formGroup.updateValueAndValidity();
});
    }

    //clearing the service, so if the user comes back to this page, the form is not prefilled again
    this.offerTransferService.clear();

    // Using Promise.resolve to ensure this code runs after the current call stack is cleared to let the form be prefilled
    Promise.resolve().then(() => {
      const obs: Observable<boolean>[] = this.formComponents.map(f =>
        merge(
          f.validStatus(),
          f.formGroup.statusChanges.pipe(
            startWith(f.formGroup.status),
            map(status => status === 'VALID')
          )
        )
      );

      this.allFormsValid$ = combineLatest(obs).pipe(
        map(results => results.every(Boolean))
      );

      this.changeDetector.detectChanges();
    });
  }

  ngOnDestroy(): void {
    this.fileUploadService.clearAll();
    this.offerFileUploadComponent.uploadComponent.clear();
    this.formComponents.destroy();
  }

  sendUploadStatus(status: boolean) {
    this.uploadInProgress.emit(status);
  }
}
